import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IonicSelectableComponent } from 'ionic-selectable';

@Component({
  selector: 'filter-selectable',
  templateUrl: './filter-selectable.component.html',
  styleUrls: ['./filter-selectable.component.scss'],
})
export class FilterSelectableComponent {
  @ViewChild('selectable') selectable: IonicSelectableComponent;

  /**
   * Data source and selection
   */
  @Input() items: any[] = [];
  @Output() selection: EventEmitter<any> = new EventEmitter();
  @Input() selectedItem: any;

  /**
   * Selectable configuration
   */
  @Input() valueField: string = 'id';
  @Input() textField: string = 'name';
  @Input() multiple: boolean = false;
  @Input() placeholder: string = '';
  @Input() label: string = '';

  itemsSelected = new FormControl();

  showItem(item: any): void {
    return item[this.textField];
  }

  save(): void {
    this.selectable.confirm();
    this.selectable.close();
    this.selection.emit(this.selectedItem);
  }
}
